import {
  AHInput,
  AHRoutineIcon,
  AHSeparator,
  Box,
  ListItem,
  useBoxStyle,
} from "arkh";

import React from "react";
import { FlatList } from "react-native";
import { useModalInsets } from "../../../components/mobile/useModalInsets";

import {
  ListSectionHeader,
  ListSectionHeaderTitle,
} from "../../../components/atoms/ListSectionHeader";
import { KPIUnitSelector } from "../components/KPIUnitSelector";
import { KPIUnit } from "../Edit/KPIEditParamList";
import { useIntl, FormattedMessage } from "react-intl";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import { RoutineIcon } from "./KPICreateParams";

function useSuggestions() {
  const intl = useIntl();

  return [
    {
      title: intl.formatMessage({
        defaultMessage: "Waste",
        description: "KPI Waste",
      }),
      icon: "waste",
      unit: "CURRENCY",
    },
    {
      title: intl.formatMessage({
        defaultMessage: "Out of Stock",
        description: "KPI Out of Stock",
      }),
      icon: "shelf_hole",
      unit: "CUSTOM",
    },
    {
      title: intl.formatMessage({
        defaultMessage: "Leftovers",
        description: "KPI Left overs",
      }),
      icon: "residual",
      unit: "CUSTOM",
    },
  ] as const;
}

export function KPICreateType(props: {
  onNext: () => void;
  isCustomKPI: boolean;
  setCusomKPI: (isCustomKPI: boolean) => void;
  setTitle: (title: string) => void;
  title: string;
  setIcon: (icon?: RoutineIcon) => void;
  icon?: RoutineIcon;
  setUnit: (unit: KPIUnit) => void;
  unit: KPIUnit;
}) {
  const insets = useModalInsets();
  const suggestions = useSuggestions();
  const contentContainerStyle = useBoxStyle({
    space: "medium",
    insets,
  });
  const intl_tokens = useIntlTokens();

  if (props.isCustomKPI) {
    return (
      <Box style={contentContainerStyle}>
        <ListSectionHeader>
          <ListSectionHeaderTitle>{intl_tokens.Name}</ListSectionHeaderTitle>
        </ListSectionHeader>
        <Box spaceBottom="large">
          <AHInput
            color="surface"
            autoFocus
            autoCorrect={false}
            cornerRadius="large"
            value={props.title}
            autoCapitalize="none"
            autoComplete="off"
            defaultStyle
            onChangeText={props.setTitle}
            space="medium"
            textType="list-item-title"
          />
        </Box>
        <KPIUnitSelector setUnit={props.setUnit} unit={props.unit} />
      </Box>
    );
  }

  return (
    <FlatList
      scrollEnabled={false}
      automaticallyAdjustContentInsets
      contentInsetAdjustmentBehavior="always"
      ItemSeparatorComponent={AHSeparator}
      contentContainerStyle={contentContainerStyle}
      data={suggestions}
      renderItem={({ item, index }) => {
        return (
          <ListItem
            border="border-primary"
            isFirst={index === 0}
            onPress={() => {
              props.setIcon(item.icon);
              props.setTitle(item.title);
              props.setUnit(item.unit);
              props.onNext();
            }}
            right={<ListItem.NavArrow />}
            left={item.icon ? <AHRoutineIcon type={item.icon} /> : null}
          >
            <ListItem.Title>{item.title}</ListItem.Title>
          </ListItem>
        );
      }}
      ListFooterComponent={
        <>
          <AHSeparator />
          <ListItem
            border="border-primary"
            isLast
            onPress={() => {
              props.setCusomKPI(true);
            }}
            right={<ListItem.NavArrow />}
          >
            <ListItem.Title>
              <FormattedMessage
                defaultMessage="Create custom KPI"
                description="Create KPI custom KPI option"
              />
            </ListItem.Title>
          </ListItem>
        </>
      }
    />
  );
}
